import { render, staticRenderFns } from "./roleInfo.vue?vue&type=template&id=92898f58"
import script from "./roleInfo.vue?vue&type=script&lang=js"
export * from "./roleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-hmt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92898f58')) {
      api.createRecord('92898f58', component.options)
    } else {
      api.reload('92898f58', component.options)
    }
    module.hot.accept("./roleInfo.vue?vue&type=template&id=92898f58", function () {
      api.rerender('92898f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/roleInfo.vue"
export default component.exports